import { Link } from 'react-router-dom';
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import './App.css';

export default function Events() {
  const { page } = useParams();
  const [, setLoaded] = useState(false);

  useEffect(() => {
    // Set loaded to true after a short delay to allow animations to occur
    const timeout = setTimeout(() => {
      setLoaded(true);
    }, 500);

    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);
  }, [page]);

  return (
    <div>
      <div id="events" className="pb-24 bg-slate-200 flex flex-col items-center">
        <h1 className="py-6 text-black text-3xl font-bold">Events:</h1>
        <h2 className=" text-red-700 text-3xl font-bold">VALENTINES EDITION ❤️</h2>
        
         
 <div className="text-black text-lg font-semibold px-4 text-center space-y-4">
  <p>
    <strong>Join us for a charity drive at Mji Wa Huruma / Nyumba ya wazee (The Elderly) on Sunday the 15th of February 2026.</strong>
  </p>

  <p>
    Located in Githogoro, Runda, we aim to bring hope, love, support and empowerment to everyone.
  </p>

  <p>
    <em>All types of donations are welcome.</em>
  </p>
</div> 

  <div className="py-2">
          <Link to="/Donate">
            <button className='text-white px-16 bg-red-800 rounded-md text-base py-2 self-start transition-transform transform hover:scale-110'>
              Take Action
            </button>
          </Link>
        </div> 
       

        {/* <p className="text-black text-lg font-semibold px-4 text-center">
        We're incredibly grateful to everyone who joined us at Lucky Summer. Your presence and support made it truly special. Stay tuned for our next event.</p>* */}

         <div className="flex justify-center w-full px-4 space-y-4 md:space-y-0 md:space-x-4">
          <div className="py-2">
            <img
              src="gallery/events/runda.jpeg"
              alt=" ~"
              className="w-96 rounded-lg shadow-lg transition-transform transform hover:scale-105"
            />
          </div>
        </div> 

        <p className="text-black text-lg font-semibold py-4 text-center">
           For more information, Contact us.
        </p>

        <div className="py-1">
          <Link to="/Contact">
            <button className='text-white px-16 bg-red-700 rounded-md text-base py-2 self-start transition-transform transform hover:scale-110'>
              Contact Us
            </button>
          </Link>
        </div>

        

      </div>
    </div>
  );
}
